export const ApprovalStatusStringMap = new Map<string, string>([
  // PLAT-4318 — no 'DRAFT' row on purpose: `approval_status` never carries the token. See the
  // note on DataSourceApprovalStatus. `PipelineStatusStringMap` DOES need one, because
  // Pipeline.status is where the pipeline draft token lives and it is serialized raw.
  ['NEW', 'New'],
  ['CATALOGUED', 'Catalogued'],
  ['UNDER_DISCOVER', 'Under Discovery'],
  ['APPROVED', 'Approved'],
  ['PENDING_APPROVAL', 'Pending Approval'],
]);
